import styled from 'styled-components';
import Button from '../../../../../_shared/components/Button';

const StyleButton = `
  margin-right: 30px;
`;

export const StyledPrimaryButton = styled(Button.Primary)`
  padding: 8px 40px;
  ${StyleButton}
`;

export const StyledSecondaryButton = styled(Button.Secondary)`
  padding: 8px 22px;
  ${StyleButton}
`;
